export enum MeridiemTimeEnum {
	AM = 'AM',
	PM = 'PM'
}